import ChatButton from "@/chatbot-library/ChatButton"
import ChatInput from "@/chatbot-library/ChatInput"
import ChatMessage from "@/chatbot-library/ChatMessage"
import ChatText from "@/chatbot-library/ChatText"
import coreApiClient from "core-api"
import InputValidation from "@/chatbot-library/InputValidation"
import store from "@/store"

const setIntroductionMessage = value => {
  store.commit("conversation/flow/setIntroductionMessage", value)
}

const setVehicleBrand = value => {
  store.commit("conversation/flow/setVehicleBrand", value)
}

const setBuyerType = value => {
  store.commit("conversation/flow/setBuyerType", value)
}

const setEmail = value => {
  store.commit("conversation/flow/setEmail", value)
}

const setPhoneNumber = value => {
  store.commit("conversation/flow/setPhoneNumber", value.replace(/\s/g, ""))
}

const createConversation = () => {
  let introductionMessage = store.state.conversation.flow.introductionMessage
  let vehicleBrand = store.state.conversation.flow.vehicleBrand
  let buyerType = store.state.conversation.flow.buyerType
  let workspaceId = store.state.workspace.id
  return coreApiClient.messages.store(introductionMessage, null, workspaceId, null, vehicleBrand, buyerType)
    .then(message => {
      let conversationId = message.conversation_id
      store.commit("conversation/flow/setConversationId", conversationId)
      return conversationId
    })
}

let chat = [
  new ChatText("introduction",
    {
      actions: [
        new ChatMessage(
          {},
          {
            next: "welcome",
            callback: setIntroductionMessage
          }
        )
      ]
    }
  ),

  new ChatText("welcome",
    {
      content: "Bienvenue !",
      next: "brand-selection"
    }
  ),

  new ChatText("brand-selection",
    () => {
      return {
        content: "Afin de vous orienter dans la bonne direction, avec quelle équipe souhaitez-vous être mis en relation ?",
        actions: [
          new ChatButton(
            { label: "Équipe Audi" },
            {
              next: "status-selection",
              callback: () => setVehicleBrand("audi")
            }
          ),
          new ChatButton(
            { label: "Équipe Seat" },
            {
              next: "status-selection",
              callback: () => setVehicleBrand("seat")
            }
          ),
          new ChatButton(
            { label: "Équipe Skoda" },
            {
              next: "status-selection",
              callback: () => setVehicleBrand("skoda")
            }
          ),
          new ChatButton(
            { label: "Équipe Volkswagen" },
            {
              next: "status-selection",
              callback: () => setVehicleBrand("volkswagen")
            }
          ),
          new ChatButton(
            { label: "Pas de préférence" },
            { next: "status-selection" }
          )
        ]
      }
    }
  ),

  new ChatText("status-selection",
    () => {
      return {
        content: "C'est noté.\nAvez-vous une préférence de conseiller avec qui vous souhaitez échanger ?",
        actions: [
          new ChatButton(
            { label: "Conseiller véhicules neufs" },
            {
              next: "fill-contact",
              callback: () => setBuyerType("new")
            }
          ),
          new ChatButton(
            { label: "Conseiller véhicules d'occasion" },
            {
              next: "fill-contact",
              callback: () => setBuyerType("occasion")
            }
          ),
          new ChatButton(
            { label: "Pas de préférence" },
            { next: "fill-contact" }
          )
        ]
      }
    }
  ),

  new ChatText("fill-contact",
    {
      content: "Donnez à notre équipe un moyen de vous contacter en cas de coupure.",
      next: "ask-email"
    }
  ),

  new ChatText("ask-email",
    () => {
      return {
        content: "Quel est votre adresse e-mail ?",
        actions: [
          new ChatInput(
            {
              label: "Confirmer",
              placeholder: "Adresse e-mail",
              mask: InputValidation.email.mask,
              validator: InputValidation.email.validator,
            },
            {
              next: "ask-phone-number",
              callback: setEmail
            })
        ]
      }
    }
  ),

  new ChatText("ask-phone-number",
    () => {
      return {
        content: "Quel est votre numéro de téléphone ?",
        actions: [
          new ChatInput(
            {
              label: "Confirmer",
              placeholder: "Numéro de téléphone",
              mask: InputValidation.phoneNumber.mask,
              validator: InputValidation.phoneNumber.validator,
            },
            {
              next: "confirm-contact",
              callback: setPhoneNumber
            })
        ]
      }
    }
  ),

  new ChatText("confirm-contact", () => {
    return {
      content: `Vous serez averti dans cette fenêtre et par ce(s) moyen(s):\n${store.state.conversation.flow.email}\n${store.state.conversation.flow.phoneNumber}`,
      next: "seller-response"
    }
  }),

  new ChatText("seller-response",
    () => {
      return store
        .dispatch("authCustomer", {
          email: store.state.conversation.flow.email,
          phone_number: store.state.conversation.flow.phoneNumber
        })
        .then(createConversation)
        .then(conversationId => {
          return {
            content: "Un conseiller va vous répondre",
            conversationId,
            actions: [
              new ChatMessage(
                {},
                {
                  callback: value => {
                    coreApiClient.messages.store(value, null, null, conversationId)
                  }
                }
              )
            ]
          }
        })
    }
  )
]

export default {
  entry: "introduction",
  chat
}
